// extracted by mini-css-extract-plugin
module.exports = {"Rename":"Rename_Rename__2elnd"};